import * as PIXI from "pixi.js";
import { ColorMatrixFilter, Container, PointData, Sprite } from "pixi.js";
import { Sheets } from "./Textures";
import { ITransform } from "./ITransform";
import { Game } from "./Game";
import { DebugShade } from "./DebugShade";
import { randomRange } from "../random";
import { Geom } from "./Geom";
import { Colors } from "./Colors";

export class Hive implements ITransform {
	public readonly container: PIXI.Container = new Container();
	private readonly sprite: Sprite;
	private readonly hitbox: DebugShade = new DebugShade();
	public size: number = 30;
	public charging: number = 0;
	private readonly maxCharge: number = 4000;
	public destroyed: boolean = false;

	private static minDistance: number = 2000;
	private static maxDistance: number = 2400;
	private static jitter: number = 400;

	public static spawnTriangle(parent: Container, radius: number): Hive[] {
		const angleOffset = Math.random() * 2 * Math.PI;
		const distance = radius//randomRange(this.minDistance, this.maxDistance);
		// Triangle: 12 o'clock, 4 o'clock, 8 o'clock at a random offset.
		const angles = [
			angleOffset + 0 / 3 * 2 * Math.PI,
			angleOffset + 1 / 3 * 2 * Math.PI,
			angleOffset + 2 / 3 * 2 * Math.PI,
		];
		return angles.map(angle => new Hive(
			parent,
			{
				x: Math.cos(angle) * distance + Math.random() * this.jitter,
				y: Math.sin(angle) * distance + Math.random() * this.jitter,
			}
		));
	}

	public constructor(parent: Container, position: PointData) {
		this.sprite = new PIXI.Sprite(Sheets.ground[5]);
		this.sprite.anchor.set(0.5, 0.5);
		this.sprite.roundPixels = true;
		this.container.addChild(this.sprite);
		this.hitbox.size = this.size;
		this.container.addChild(this.hitbox.graphics);
		parent.addChild(this.container);
		this.x = position.x;
		this.y = position.y;
	}

	public destroy() {
		this.container.removeFromParent()
		this.destroyed = true;
	}

	public tick(deltaMS: number, game: Game) {
		this.hitbox.graphics.visible = game.showHitboxes;
		if (game.player.highlightedItem == this && game.keys.e.held) {
			if (this.charging == 0) {
				this.sprite.filters = [new ColorMatrixFilter()];
			}
			this.charging += deltaMS;
		} else {
			this.charging = 0;
		}
		if (this.charging == 0) {
			this.sprite.filters = [];
		} else {
			const t = this.charging / this.maxCharge;
			(this.sprite.filters as ColorMatrixFilter[])[0].matrix = Colors.flashWhite(
				Geom.remap(0, 1, t, 0.1, 0.6)
			);
			this.sprite.scale = 1 + Math.sin(this.charging / 100) / 10 + t / 5;
		}
		if (this.charging >= this.maxCharge) {
			game.nextStage();
		}
	}

	public highlight() {
		this.hitbox.color = 0xff0000;
	}

	public unhighlight() {
		this.hitbox.color = 0x000000;
	}

	// region ITransform

	public get x(): number {
		return this.container.x;
	}

	public set x(value: number) {
		this.container.x = value;
	}

	public get y(): number {
		return this.container.y;
	}

	public set y(value: number) {
		this.container.y = value;
	}

	public get w(): number {
		return this.container.width;
	}

	public get h(): number {
		return this.container.height;
	}

	// endregion
}
